import { render, staticRenderFns } from "./informationUp.vue?vue&type=template&id=8072d700&scoped=true&"
import script from "./informationUp.vue?vue&type=script&lang=js&"
export * from "./informationUp.vue?vue&type=script&lang=js&"
import style0 from "./informationUp.vue?vue&type=style&index=0&id=8072d700&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8072d700",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/vue-sellerwell-web-erp-service-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8072d700')) {
      api.createRecord('8072d700', component.options)
    } else {
      api.reload('8072d700', component.options)
    }
    module.hot.accept("./informationUp.vue?vue&type=template&id=8072d700&scoped=true&", function () {
      api.rerender('8072d700', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tips/informationUp.vue"
export default component.exports